/**
 * Web application configuration, resolved from Vite's import.meta.env.
 */

import { createAppConfig, ENTITLEMENT_ID } from '@chordbookpro/shared';

export const config = createAppConfig({
  env: import.meta.env,
  prefix: 'VITE_',
});

/** Firebase client configuration. These values are public by design. */
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

/** True when enough Firebase config is present to attempt initialization. */
export const isFirebaseConfigured = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId);

export const authEmulatorUrl = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_URL ?? null;

/** RevenueCat Web Billing — public SDK key only. */
export const revenueCatConfig = {
  apiKey: import.meta.env.VITE_REVENUECAT_WEB_API_KEY ?? '',
  entitlementId: import.meta.env.VITE_REVENUECAT_ENTITLEMENT_ID ?? ENTITLEMENT_ID,
  offeringId: import.meta.env.VITE_REVENUECAT_OFFERING_ID ?? 'default',
};

// The fallback identifier is only correct if the dashboard happens to use it.
// When it does not, entitlement checks silently return false and a subscriber
// looks like a Free user, so the guess is announced rather than made quietly.
if (!import.meta.env.VITE_REVENUECAT_ENTITLEMENT_ID && revenueCatConfig.apiKey) {
  console.warn(
    `VITE_REVENUECAT_ENTITLEMENT_ID is not set; assuming "${ENTITLEMENT_ID}". ` +
      'If the RevenueCat dashboard uses a different identifier, Premium will never be detected.',
  );
}

export const isBillingConfigured = Boolean(revenueCatConfig.apiKey);

export const apiUrl = import.meta.env.VITE_API_URL ?? '/api/v1';
